import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { NgxSpinnerService } from 'ngx-spinner';
import { Observable, Subject } from 'rxjs';
import { CoreHelperService } from 'src/app/providers/core-helper/core-helper.service';
import { CoreHttpService } from 'src/app/providers/core-http/core-http.service';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})

export class HeaderService extends CoreHttpService {
  callpatientserach = new Subject();

  private userUrl: string = `${environment.apiUrl}/User`;
  private cereusReportUrl: string = `${environment.apiUrl}/CereusReports`;
  private notificationUrl: string = `${environment.apiUrl}/Notification`;

  constructor(
    public _coreHelper: CoreHelperService,
    private _http: HttpClient,
    router: Router,
    spinner: NgxSpinnerService
  ) {
    super(_http, router, spinner);
  }


  public patientSearch() {
    this.callpatientserach.next(true);
  }


  /* profile notification setting*/
  GetNotificationSettingsByUserId(): Observable<any> {
    return this.get(`${this.notificationUrl}/GetNotificationSettingsByUserId`)
  }

  UpdateNotificationSettings(model): Observable<any> {
    return this.put(`${this.notificationUrl}/UpdateNotificationSettingsByUserId`, model);
  }

  markNotificationDisplayed(requestModel: any): Observable<any> {
    return this.postParams(`${this.notificationUrl}/MarkNotificationDisplayed`, "", requestModel);
  }
  /* profile notification setting*/


  //#region User Notification Messages
  getNotificationByUserId(): Observable<any> {
    return this.get(`${this.notificationUrl}/GetNotificationByUserId`);
  }

  markNotificationAsReaded(requestModel: any): Observable<any> {
    return this.post(`${this.notificationUrl}/MarkNotificationRead`, requestModel);
  }
  //#endregion

  getQuickReportData(params: any): Observable<any> {
    return this.post(`${this.cereusReportUrl}/quickreport-data`, params);
  }

  getQuickVobData(params: any): Observable<any> {
    return this.post(`${this.cereusReportUrl}/quickvob-data`, params);
  }

  getPageTitleFromUrl(paramUrl: string, isSpecialist: boolean, isQualityAnalyst: boolean): string {
    const ApplicationUrlList = [
      // Dashboard
      { path: '/auth/dashboard', pageTitle: 'Dashboard' },
      { path: '/auth/vob-dashboard', pageTitle: 'Dashboard' },
      { path: '/auth/auth-dashboard', pageTitle: 'Utilization Review' },
      { path: '/auth/facility-dashboard', pageTitle: 'Facility Dashboard' },

      // Resource
      { path: '/auth/resource/facility/facility-grouping', pageTitle: 'Facility Group' },
      { path: '/auth/resource/facility/facility-master', pageTitle: 'Facility Master' },
      { path: '/auth/resource/facility/carriers-master', pageTitle: 'Carrier Master' },
      { path: '/auth/resource/facility/patients', pageTitle: 'Patient Master' },

      // Services
      { path: '/auth/services/vob', pageTitle: 'VOB' },
      { path: '/auth/services/billing', pageTitle: 'Billing' },
      { path: '/auth/services/bulk-upload-vob', pageTitle: 'Upload Bulk VOB Request' },
      { path: '/auth/services/vob-explorer', pageTitle: 'Vob Explorer' },
      { path: '/auth/services/document', pageTitle: 'Document Vault' },
      { path: '/auth/services/authorization', pageTitle: 'Utilization Review' },
      { path: '/auth/auth-specialist', pageTitle: 'Utilization Review' },
      { path: '/auth/auth-email-request', pageTitle: 'Utilization Review' },
      { path: '/auth/services/tpn', pageTitle: 'TPN' },
      { path: '/auth/services/vob-email-request', pageTitle: 'Vob Request' },

      // Reports
      { path: '/auth/report/claims-billed', pageTitle: 'Claims Billed' },
      { path: '/auth/report/payment-summary', pageTitle: 'Payment Summary' },
      { path: '/auth/report/patient-statement', pageTitle: 'Patient Statement' },
      { path: '/auth/report/call-record-analytics', pageTitle: 'Call Record Analytics' },
      { path: '/auth/report/payment-detail', pageTitle: 'Payment - Detail' },
      { path: '/auth/report/aging', pageTitle: 'Current Payer Breakdown' },
      { path: '/auth/report/aging-summary', pageTitle: 'AR Aging Summary' },
      { path: '/auth/report/ur-daily', pageTitle: 'UR Daily Authorizations' },
      { path: '/auth/report/ur-review', pageTitle: 'UR Upcoming Review' },
      { path: '/auth/report/activity-summary', pageTitle: 'Activity Summary By Month' },
      { path: '/auth/report/payer-priority', pageTitle: 'Total Balance by Payer Priority' },
      { path: '/auth/report/patient-balance', pageTitle: 'Patient Balance Report' },
      { path: '/auth/report/payer-type', pageTitle: 'Payer Type Breakdown' },

      { path: '/auth/report/auth-overview', pageTitle: 'Utilization Review' },
      { path: '/auth/report/cereus-overview', pageTitle: this._coreHelper.getUserDomain() === 1 ? 'Facility Dashboard' : 'Overview' },
      { path: '/auth/report/charges-billed-datasource', pageTitle: 'Charges Billed - Source Data' },
      { path: '/auth/report/charges-billed-summary', pageTitle: 'Charges Billed - Summary' },
      { path: '/auth/report/charges-billed-details', pageTitle: 'Charges Billed - Detail' },
      { path: '/auth/report/charges-billed-yearlytrend', pageTitle: 'Charges Billed - Yearly Trend' },
      { path: '/auth/report/charges-billed-pendingclaims', pageTitle: 'Charges Billed - Pending Claims' },
      { path: '/auth/report/tpn-report', pageTitle: 'Third Party Negotiations' },
      { path: '/auth/report/payments-report', pageTitle: 'Payment - Summary' },
      { path: '/auth/report/payments-datasource-report', pageTitle: 'Payment - Data Source' },
      { path: '/auth/report/payment-details-report', pageTitle: 'Payment - Details' },
      { path: '/auth/report/payment-yearlytrend-report', pageTitle: 'Payment - Yearly Trend' },
      { path: '/auth/report/ar-opencharges', pageTitle: 'Account Receivable - Open Charges' },
      { path: '/auth/report/ar-payer-waterfall', pageTitle: 'Account Receivable - AR Burndown' },
      { path: '/auth/report/ar-patient-balance', pageTitle: 'Account Receivable - Patient Balance' },
      { path: '/auth/report/ar-payer-breakdown', pageTitle: 'Account Receivable - Payer Breakdown' },
      { path: '/auth/report/claim-status-pending', pageTitle: 'Claim Status - Pending' },
      { path: '/auth/report/claim-status-progress', pageTitle: 'Claim Status - In Progress' },
      { path: '/auth/report/claim-status-mrescalation', pageTitle: 'Claim Status - Medical Records / Escalations' },
      { path: '/auth/report/claim-status-overview', pageTitle: 'Claim Status - Overview' },
      { path: '/auth/report/policy-lookup', pageTitle: 'Policy Lookup' },
      { path: '/auth/report/charges-projected', pageTitle: 'All Charges Projected' },
      { path: '/auth/report/monthly-projection', pageTitle: 'Monthly Projections' },
      { path: '/auth/report/census-projected', pageTitle: 'Projected Census Value' },
      { path: '/auth/report/quick-patient-caseview', pageTitle: 'Patient Case View' },

      // User Configurations
      { path: '/auth/administration/permission', pageTitle: 'Permission' },
      { path: '/auth/administration/user-configurations', pageTitle: 'User Configurations' },
      { path: '/auth/administration/announcement', pageTitle: 'Announcement' },
      { path: '/auth/administration/diagnostic', pageTitle: 'Diagnostic Code' },
      { path: '/auth/administration/document-workflow', pageTitle: 'Document Type' },
      { path: '/auth/administration/status-workflow', pageTitle: 'Status Workflow' },
      { path: '/auth/administration/module', pageTitle: 'Module Master' },
      { path: '/auth/administration/facility-documents', pageTitle: 'Facility Documents' },
      { path: '/auth/administration/service', pageTitle: 'Service Master' },
      { path: '/auth/administration/service-type', pageTitle: 'Service Type Master' },
      { path: '/auth/administration/taxonomy', pageTitle: 'Facility Identifier' },
      { path: '/auth/administration/message-configuration', pageTitle: 'Message Configuration' },
      { path: '/auth/administration/tpn-master', pageTitle: 'Third Party Master' },
      { path: '/auth/administration/tenure-goals', pageTitle: 'Tenure Goals' },
      { path: '/auth/administration/payment-task', pageTitle: 'Payment Task' },
      { path: '/auth/administration/upload-type-master', pageTitle: 'Upload File' },
      { path: '/auth/administration/email-template', pageTitle: 'Email Template' },
      { path: '/auth/administration/scheduled-reports', pageTitle: 'Scheduler Settings' },
      // Profile
      { path: '/auth/profile', pageTitle: 'Profile' },
      { path: '/auth/profile/change-password', pageTitle: 'Change Password' },
      { path: '/auth/setting', pageTitle: 'Notification Settings' },
      { path: '/auth/patient-case-view', pageTitle: 'Client Case View' },
      { path: '/auth/services/patient-cases', pageTitle: 'Patient Cases' },
      { path: '/auth/administration/role-builder', pageTitle: 'Role Builder' },
      { path: '/auth/administration/license-package', pageTitle: 'License Package' },
    ]

    const foundItem = ApplicationUrlList.find(element =>
      paramUrl.includes(element.path)
    );

    if (foundItem && foundItem.pageTitle.length > 0) {
      if (foundItem.pageTitle.toLowerCase().match('vob')) {
        if (isSpecialist)
          return 'Specialist - Dashboard';
        else if (isQualityAnalyst)
          return 'QA - Dashboard';
        else
          return 'VOB';
      }
      else if (foundItem.pageTitle.toLowerCase().match('auth-dashboard')) {
        if (isSpecialist)
          return 'Specialist - Dashboard';
        else if (isQualityAnalyst)
          return 'QA - Dashboard';
        else
          return 'Authorization Dashboard';
      }
    }

    if (foundItem && foundItem.pageTitle.length > 0)
      return foundItem.pageTitle;


    // UrlString Mapping
    const UrlInStringList = [
      { path: 'view-facility', pageTitle: 'Facility Info' },
      { path: 'facility-info', pageTitle: 'Facility Info' },
      { path: 'add-facility', pageTitle: 'Add Facility' },
      { path: 'edit-facility', pageTitle: 'Edit Facility' },
      { path: 'view-facility', pageTitle: 'View Facility' },
      { path: 'add-carriers', pageTitle: 'Add Carrier' },
      { path: 'edit-carriers', pageTitle: 'Edit Carrier' },
      { path: 'view-carriers', pageTitle: 'View Carrier' },
      { path: 'add-patients', pageTitle: 'Add Patient' },
      { path: 'edit-patients', pageTitle: 'Edit Patient' },
      { path: 'view-patients', pageTitle: 'View Patient' },
      { path: 'add-vob', pageTitle: 'VOB' },
      { path: 'edit-vob', pageTitle: 'VOB' },
      { path: 'view-vob', pageTitle: 'VOB' },
      { path: 'add-authorization', pageTitle: 'Authorization' },
      { path: 'edit-authorization', pageTitle: 'Authorization' },
      { path: 'view-authorization', pageTitle: 'Authorization' },
      { path: 'add-tpn', pageTitle: 'TPN' },
      { path: 'edit-tpn', pageTitle: 'TPN' },
      { path: 'view-tpn', pageTitle: 'TPN' },
      { path: 'view-single-case-agreements', pageTitle: 'View Single Case' },
      { path: 'patient-case-view', pageTitle: 'Client Case View' },
      { path: 'Permission', pageTitle: 'Permission' },
      { path: 'daily-production-report', pageTitle: 'Daily Production Report' },
      { path: 'quality-report', pageTitle: 'Quality Report' },
      { path: 'tat-report', pageTitle: 'TAT Report' },
      { path: 'call-metrics-report', pageTitle: 'Call Metrics Report' },
      { path: 'specialist-break-report', pageTitle: 'Specialist Break Report' },
      { path: 'volume-report', pageTitle: 'VOB Volume Report' },
      { path: 'reassign-report', pageTitle: 'Reassign / Rework Report' },
      { path: 'missing-information-report', pageTitle: 'Missing Information Report' },
      { path: 'facility-payer-report', pageTitle: 'Facility/Payer Report' },
      { path: 'specialist-performance-report', pageTitle: 'Specialist Performance Report' },
      { path: 'vob-dna', pageTitle: 'VOB DNA Summary' },
      { path: 'vob-email-request', pageTitle: 'VOB Request' },
      { path: 'vob', pageTitle: 'VOB Request' },
    ];

    const foundItemString = UrlInStringList.find(element =>
      paramUrl.includes(element.path)
    );
    if (foundItemString && foundItemString.pageTitle.length > 0)
      return foundItemString.pageTitle;

    return 'Dashboard';
  }
}